import React from "react";
import "./lectueres.scss";
export const Lecturers = ({ data }) => {
  return (
    <div className="lecturers-component col-md-3">
      <div className="col-md-12 lec-overlay">
        {" "}
        <img className="" src={data.img} alt="Scholar" width="100%" />
        <div className="overlay"></div>
      </div>

      <div className="profile-div">
        <center style={{ height: "100px" }}>
          <h4>{data.name}</h4>
          <h5 style={{ color: "grey" }}>{data.position}</h5>
        </center>
        <center>
          <p>{data.info}</p>
        </center>
        <ul className="list-inline mt4">
          <li className="list-inline-item">
            <a href={data.fbhandle} className="socials" target="_blank"></a>
            <i class="icofont-facebook"></i>
          </li>
          <li className="list-inline-item">
            <a
              href={data.linkedinhandle}
              className="socials"
              target="_blank"
            ></a>
            <i class="icofont-linkedin"></i>
          </li>
          <li className="list-inline-item">
            <a href={data.emailhandle} className="socials" target="_blank"></a>
            <i class="icofont-email"></i>
          </li>
          <li className="list-inline-item">
            <a
              href={data.twitterHandle}
              className="socials"
              target="_blank"
            ></a>
            <i class="icofont-twitter"></i>
          </li>
        </ul>
      </div>
    </div>
  );
};
